import {
  UnavailableOfferReason,
  parseUnavailableOfferReason,
} from 'experiments/deeplinks-flow-feature/treatment/features/offer/utils/unavailable-offer-reason';
import { useDeeplinksFlowEnabled } from 'experiments/deeplinks-flow-feature/use-deeplinks-flow-experiment';
import { useRoute } from 'hooks/navigation/use-route';
import { LoyaltyEngineId } from 'state/loyalty/types';

interface ILoyaltyOffersParams {
  offerEngineId?: string | string[];
  unavailableItemId?: string | string[];
  unavailableReason?: string | string[];
}

interface ILoyaltyOffersFlow {
  loyaltyEngineId: LoyaltyEngineId;
  deeplinkUnavailableOfferEngineId: LoyaltyEngineId;
  deeplinkUnavailableReason?: UnavailableOfferReason;
}

function normalizeParam(value?: string | string[]): string {
  return (Array.isArray(value) ? value[0] : value ?? '').trim();
}

// This hook should be removed when we split OfferList from OfferDetails components
const useLoyaltyOffersFlow = (): ILoyaltyOffersFlow => {
  const { params } = useRoute<ILoyaltyOffersParams>();
  const loyaltyEngineId = normalizeParam(params?.offerEngineId) as LoyaltyEngineId;
  const unavailableItemId = normalizeParam(params?.unavailableItemId);
  const isDeeplinksFlowEnabled = useDeeplinksFlowEnabled();

  // Unavailable recovery requires the explicit `unavailableItemId` marker that
  // offer detail sets once it has settled the offer as unavailable. An ordinary
  // `offerEngineId` deeplink must keep its normal auto-open behavior instead of
  // being pinned as unavailable.
  const isUnavailableRecovery =
    isDeeplinksFlowEnabled && !!unavailableItemId && unavailableItemId === loyaltyEngineId;

  return {
    loyaltyEngineId,
    deeplinkUnavailableOfferEngineId: isUnavailableRecovery
      ? loyaltyEngineId
      : ('' as LoyaltyEngineId),
    deeplinkUnavailableReason: isUnavailableRecovery
      ? parseUnavailableOfferReason(normalizeParam(params?.unavailableReason))
      : undefined,
  };
};

export default useLoyaltyOffersFlow;
